module.exports = __webpack_public_path__ + "static/img/index.67c5a42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index.png
// module id = zICw
// module chunks = 1